// Gráfica de barras: evolución histórica del indicador RevPASH (Revenue per
// Available Seat Hour). Consume GET /api/financiero/revpash.
// Fórmula: Ventas ÷ (asientos × horas de operación × días del mes).
import { useMemo } from "react";
import { Card, Title, Text, BarChart } from "@tremor/react";
import { PALETTE } from "../lib/palette";

interface RevPASHRow {
  mm: number;
  mes_label: string;
  ventas: number | null;
  sillas: number | null;
  horas: number | null;
  dias: number | null;
  revpash: number | null;
}

interface RevPASHResponse {
  restaurant_id: string;
  anio: number;
  rows: RevPASHRow[];
}

const fmtS = (n: number | null) =>
  n == null ? "—" : "S/ " + n.toLocaleString("es-PE", { maximumFractionDigits: 2 });

export default function RevPASHBarras({ data }: { data: RevPASHResponse }) {
  const serie = useMemo(
    () =>
      data.rows.map((r) => ({
        mes: r.mes_label,
        revpash: r.revpash != null ? r.revpash : 0,
        // para tooltip
        detalle:
          r.ventas != null && r.sillas && r.horas && r.dias
            ? `${fmtS(r.ventas)} ÷ (${r.sillas} as × ${r.horas}h × ${r.dias}d)`
            : "s/d",
      })),
    [data]
  );

  const hayDatos = data.rows.some((r) => r.revpash != null);

  return (
    <Card className="!p-3">
      <Title className="!text-base">RevPASH (evolución histórica)</Title>
      <Text className="!text-xs">
        Ventas ÷ (asientos × horas × días) · S/ por asiento-hora
      </Text>
      {hayDatos ? (
        <BarChart
          className="mt-3 h-64"
          data={serie}
          index="mes"
          categories={["revpash"]}
          colors={[PALETTE.primaryMedium]}
          valueFormatter={(v: number) => `S/ ${v.toFixed(2)}`}
          yAxisWidth={56}
          showLegend={false}
          showAnimation={false}
        />
      ) : (
        <Text className="mt-3 !text-xs text-tremor-content">
          Sin datos de ocupabilidad/ventas para graficar RevPASH.
        </Text>
      )}
    </Card>
  );
}
